import Schema from "../details/validation";
import { getColumnSize } from "modules/common/services/table/size-storage";
import { getFieldLabel } from "modules/common/services/form/fields";
import { fieldsList } from "modules/dictionaries/order-indicators/models/order-indicator";
import { ColDef } from "ag-grid-community";
import { RowNumberColumn } from "modules/common/services/table/helpers";

const schema = Schema();

export const columns = (tableName: string) => {
    const columnSize = getColumnSize(tableName);

    const result: ColDef[] = [
        RowNumberColumn(false, ""),
        {
            headerName: getFieldLabel(fieldsList.label, schema, null),
            field: fieldsList.label,
            width: columnSize(fieldsList.label, 400),
            flex: 1,
            sortable: true,
            resizable: false,
        },
        {
            headerName: getFieldLabel(fieldsList.description, schema, null),
            field: fieldsList.description,
            width: columnSize(fieldsList.description, 200),
            sortable: false,
            resizable: true,
        },
    ];

    return result;
};
